module.exports = __webpack_public_path__ + "static/media/download.94107049.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tocollege/download.png
// module id = 143
// module chunks = 0